import DetailsList from "@/modules/company/stores/employees/details/employee_details_list.store";
import DetailsForm from "@/modules/company/stores/employees/details/employee_details_form.store";
import GeneralDetailsForm from "@/modules/company/stores/employees/details/employee_general_details_form.store";

// company.employee.EmployeeDetails.*
export default {
  modules: { DetailsList, DetailsForm, GeneralDetailsForm },
};
